module.exports = __webpack_public_path__ + "img/diners.e8bc0286.svg";